import CryptoJS from "crypto-js";

/**
 * Generates an MD5 checksum for a given file and returns it as a Base64-encoded string.
 *
 * @param file - The file for which the MD5 checksum will be generated.
 * @returns A promise that resolves to the Base64-encoded MD5 checksum of the file.
 */
export const createMD5Checksum = async (file: File): Promise<string> => {
  const fileArray = await file.arrayBuffer();
  const wordArray = CryptoJS.lib.WordArray.create(fileArray);
  const md5 = CryptoJS.MD5(wordArray);
  const base64 = md5.toString(CryptoJS.enc.Base64);
  return base64;
};
